import React from 'react'
import NotFounfImg from "../assets/images/404 error.png"
const NotFound = () => {
  return <>
  <section className='vh-100 d-flex justify-content-center align-items-center'>
    <img src={NotFounfImg} width={500} alt="NotFounfImg" />
  </section>
  </>
}

export default NotFound